import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const filtersSlice = createSlice({
  name: 'filtersSlice',
  initialState: {
    vaccinationRegistry: {},
    vaccinationRegistryArchive: {},
    pathologyActs: {},
  },
  reducers: {
    setVaccinationRegistryFilters(state, action: PayloadAction<Record<string, any>>) {
      state.vaccinationRegistry = action.payload;
    },
    setVaccinationRegistryArchiveFilters(
      state,
      action: PayloadAction<Record<string, any>>,
    ) {
      state.vaccinationRegistryArchive = action.payload;
    },
    setPathologyActsFilters(state, action: PayloadAction<Record<string, any>>) {
      state.pathologyActs = action.payload;
    },
  },
});

export const {
  setVaccinationRegistryFilters,
  setVaccinationRegistryArchiveFilters,
  setPathologyActsFilters,
} = filtersSlice.actions;
